export default {"src":"/_next/static/media/suitcase.a8bd4896.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};